<template>
  <div>
    <div class="page-group1" v-if="courses.course_type == 3">
      <div class="title-m">
        <div>
          <p class="font-p">
            <span class="class-big">{{ courses._type }}</span
            >{{ courses.title }}
          </p>
          <p class="time-p">
            <span class="fl"
              >{{ courses.openDate }} / {{ courses.lesson_count }}课时</span
            >
            <span class="fr">{{
              parseInt(courses.price) > 0 ? "￥" + courses.price : "免费"
            }}</span>
            <br />
          </p>
          <p v-if="counterShow" style="font-size: 10px; color: red">
            距离开课还剩：<span class="class_time">{{ counterText }}</span>
          </p>
          <div style="clear: both"></div>
          <p class="avatar-class">
            <img :src="courses.teacher.avatar_url" alt="" class="p-image" />
            <span class="avatar-name">{{ courses.teacher.nickname }}</span>
          </p>
        </div>
        <div>
          <p class="font-p">课程简介</p>
          <div
            v-if="courses.video_url"
            id="video"
            style="width: 100%; margin: 10px 0; height: 190px"
          >
            <video
              :src="courses.video_url"
              width="100%"
              height="100%"
              autoplay="autoplay"
              controls="controls"
              style="width: 100%; height: 100%; background-color: rgb(0, 0, 0)"
            ></video>
          </div>
          <div
            style="margin: 10px 0; width: 100%"
            class="p-details"
            v-html="courses.description"
          ></div>
        </div>
        <div>
          <p class="font-p">课程大纲</p>
          <ul v-for="item in courses.catalog" :key="item.chapter_id">
            <li
              class="ui-li-core"
              v-for="(it, idx) in item.live_list"
              :key="it.lesson_id"
            >
              <p class="class-time-p">
                <span class="clas-num">{{ idx + 1 }}</span
                >{{ it.title }}
              </p>
              <p>
                <span class="class-time">
                  {{ changeTime(it.start_time) }}
                  -
                  {{ changeTime(it.end_time) }}
                </span>
              </p>
              <ul class="class-desri">
                <li>{{ it.sub_title }}</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="class-footer centerOtherBut">
        <div class="class-hello" @click="showAppDialog">咨询</div>
        <div class="class-buy" @click="showAppDialog">立即预约</div>
      </div>
    </div>
    <div v-else class="page-group2">
      <div>
        <div class="videobox" style="position: relative">
          <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
          <div
            id="video"
            style="
              width: 100%;
              background-color: rgb(0, 0, 0);
              overflow: hidden;
              position: relative;
            "
          >
            <div
              style="background-color: rgb(0, 0, 0); width: 100%; height: 100%"
            >
              <video
                :src="courses.video_url"
                width="100%"
                height="100%"
                :poster="courses.cover_image_url"
                controls="controls"
                playsinline=""
                style="
                  width: 100%;
                  height: 100%;
                  background-color: rgb(0, 0, 0);
                "
              ></video>
            </div>
          </div>
        </div>
        <div class="m-rig">
          <p>
            <span class="m-title">{{ courses.title }}</span>
            <span class="fr m-intro m-up" @click="toggleTeacherDetail"
              >简介 &nbsp; {{ this.teacherDetailShow ? "∨" : ">" }}</span
            >
          </p>
          <div class="clear"></div>
          <p>
            <span>
              <span
                v-for="(item, index) in courses.tags"
                :key="index"
                class="c-tags"
                >{{ item }}</span
              >
            </span>
            <span class="fr play-num">播放次数：{{ courses.play_count }}</span>
          </p>
        </div>
        <div class="m-rig-40" v-show="teacherDetailShow">
          <p class="otherBut">
            <img :src="courses.cover_image_url" alt="" class="p-image" />
            <span class="p-name"
              ><b>{{ courses.teacher.nickname }}</b>
              <span class="fr p-follow" @click="showAppDialog">+ 关注</span>
            </span>
          </p>
          <p class="class-time">
            <span>共授课时：{{ courses.lesson_count }}</span>
            <span class="fr">授课时长：{{ courses.duration }}分钟</span>
          </p>
          <p class="class-details" v-html="courses.description"></p>
        </div>
      </div>
      <div class="class-group">
        <ul>
          <li class="fl" @click="changeActiveTab(1)">
            视频
            <div :class="activeTab == 1 ? 'list-g' : 'list-g dis-y'">
              &nbsp; &nbsp; &nbsp; &nbsp;
            </div>
          </li>
          <li calss="fl" @click="changeActiveTab(2)">
            互动
            <div :class="activeTab == 2 ? 'list-g' : 'list-g dis-y'">
              &nbsp; &nbsp; &nbsp; &nbsp;
            </div>
          </li>
        </ul>
        <div>
          <div v-if="activeTab == 1" class="m-rig m-class-group class-big">
            <div>
              <p class="m-title">选集</p>
              <div class="class-num">
                <span
                  v-for="item in courses.catalog"
                  :key="item.chapter_id"
                  :class="activeChapter == item.chapter_id ? 'da-color' : ''"
                  @click="changeActiveChapter(item.chapter_id)"
                  >{{ item.title }}</span
                >
              </div>
            </div>
            <div class="clear"></div>
            <div class="z-j otherBut">
              <p class="m-title">章节</p>
              <div>
                <div
                  v-for="item in courses.catalog"
                  :key="item.chapter_id"
                  class="m-title-details show otherBut"
                >
                  <ul v-if="activeChapter == item.chapter_id">
                    <li
                      v-for="it in item.video_list"
                      :key="it.lesson_id"
                      :class="it.price ? 'li-sun has_money' : 'li-sun'"
                      @click="showAppDialog"
                    >
                      {{ it.title }}
                      <span v-if="it.price" class="class_money">￥</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div v-if="activeTab == 2" class="otherBut class-big common-all">
            <ul>
              <li style="text-align: center; border: none">暂时没有评论</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-if="appDialogShow" class="tipClass"></div>
    <div v-if="appDialogShow" class="tipShow">
      <div class="clone-x" @click="hideAppDialog">
        <img
          src="https://aliyunosszs.musicwow.com/public/attachment/201901/23/00/5c46d799b9c22.png"
        />
      </div>
      <div>
        <img
          src="https://aliyunosszs.musicwow.com/public/attachment/201901/23/00/5c46d7607cf25.png"
        />
      </div>
      <p>多一种沟通方式</p>
      <button
        onclick="window.location.href='http://a.app.qq.com/o/simple.jsp?pkgname=com.conwaysmusic.live'"
      >
        下载音乐窝APP<img
          src="https://aliyunosszs.musicwow.com/public/attachment/201901/23/00/5c46d781bbe34.png"
        />
      </button>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
export default {
  name: "course",
  data() {
    return {
      courses: {
        teacher: {},
      },
      counterShow: false,
      counterText: "",
      appDialogShow: false,
      activeTab: 1,
      activeChapter: 0,
      teacherDetailShow: false,
    };
  },
  methods: {
    changeTime(num) {
      let date = new Date(num);
      let h = date.getHours();
      let m = date.getMinutes();
      let s = date.getSeconds();
      h = h < 10 ? "0" + h : h;
      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      return h + ":" + m + ":" + s;
    },
    setCounter(ori) {
      var second = Math.floor(ori % 60);
      var minutes = Math.floor((ori / 60) % 60);
      var hour = Math.floor((ori / 3600) % 24);
      var day = Math.floor(ori / (3600 * 24));
      let text = "";
      if (day) {
        text = day + "天";
      } else if (hour) {
        text = hour + "小时";
      } else if (minutes) {
        text = minutes + "分钟";
      } else if (second) {
        text = second + "秒";
      }
      this.counterText = text;
    },
    showAppDialog() {
      this.appDialogShow = true;
    },
    hideAppDialog() {
      this.appDialogShow = false;
    },
    changeActiveTab(n) {
      this.activeTab = n;
    },
    changeActiveChapter(cid) {
      this.activeChapter = cid;
    },
    toggleTeacherDetail() {
      this.teacherDetailShow = !this.teacherDetailShow;
    },
  },
  mounted() {
    this.$ajax({
      method: "get",
      url:
        process.env.VUE_APP_CONT_API +
        "api/v1/course/detail?course_id=" +
        this.$route.query.id,
      headers: {
        "X-DEVICE-TYPE": "5",
        "X-APP-NAME": "musicwow",
      },
    }).then((res) => {
      // console.log(res);
      // 处理课程类型
      if (res.data.error_code == 0) {
        let _type = "";
        let course = res.data.data;
        this.courses = course;
        switch (course.course_type) {
          case 1:
            _type = "wow趣";
            break;
          case 2:
            _type = "录播课";
            break;
          case 3:
            _type = "直播课";
            break;
          case 4:
            _type = "教材";
            break;
          case 5:
            _type = "超级网络课";
            break;
        }
        this.courses._type = _type;
        // 处理开始结束时间
        let openDate = "";
        let countdown = 0;
        if (course.course_type == 3) {
          let start = "";
          let end = "";
          if (course.catalog[0]) {
            if (course.catalog[0].live_list[0]) {
              start = course.catalog[0].live_list[0].start_time;
              let a = course.catalog.slice(-1);
              let b = a[0].live_list.slice(-1);
              end = b[0].end_time;
              countdown = course.catalog[0].live_list[0].count_down;
            }
          }
          start = new Date(start);
          end = new Date(end);
          let dstart = start.getMonth() + 1 + "月" + start.getDate() + "日";
          let dend = end.getMonth() + 1 + "月" + end.getDate() + "日";
          // console.log(dstart);
          // console.log(dend);
          if (dstart === dend) {
            openDate = dstart;
          } else {
            openDate = dstart + "-" + dend;
          }
          // 开始提示
          if (countdown) {
            this.counterShow = true;
            let counter = setInterval(() => {
              this.setCounter(countdown);
              countdown = countdown - 1;
              if (countdown == 0) {
                clearInterval(counter);
                this.counterShow = false;
              }
            }, 1000);
          }
          // console.log(openDate);
          this.courses.openDate = openDate;
        } else {
          if (course.catalog[0]) {
            this.activeChapter = course.catalog[0].chapter_id;
          }
        }
      }
    });
    // 分享
    this.$ajax({
      method: "post",
      url: process.env.VUE_APP_CONT_API + "api/v1/course/share",
      headers: {
        "X-DEVICE-TYPE": "5",
        "X-APP-NAME": "musicwow",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      params: { course_id: this.$route.query.id },
    }).then((res) => {
      if (res.data.error_code == 0) {
        let option = res.data.data.wechat_config;
        wx.config({
          appId: option.app_id,
          timestamp: option.timestamp,
          nonceStr: option.nonce_str,
          signature: option.signature,
          jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"],
        });
        wx.ready(function () {
          wx.updateTimelineShareData({
            title: res.data.data.title,
            link: res.data.data.url,
            imgUrl: res.data.data.image_url,
            success: function () {
              // console.log("设置成功");
            },
          });
          wx.updateAppMessageShareData({
            title: res.data.data.title,
            desc: res.data.data.content,
            link: res.data.data.url,
            imgUrl: res.data.data.image_url,
            success: function () {
              // console.log("设置成功");
            },
          });
        });
      }
    });
  },
};
</script>
<style lang="scss" scoped>
* {
  color: #666666;
  margin: 0;
  padding: 0;
  font-size: 16px;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.clear {
  clear: both;
}
.show {
  display: inline !important;
}
.hide {
  display: none !important;
}
li {
  list-style: none;
  margin: 0px;
}
a {
  text-decoration: none;
}
.tipClass {
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  z-index: 8;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.tipShow {
  position: fixed;
  z-index: 9;
  top: 5.5rem;
  bottom: 0;
  left: 0px;
  right: 0px;
  width: 6rem;
  height: 5rem;
  background: #fff;
  border-radius: 0.07rem;
  text-align: center;
  padding: 0.3rem;
  margin-left: auto;
  margin-right: auto;
}

.tipShow > div:nth-child(1) {
  text-align: right;
}
.tipShow > div:nth-child(1) img {
  text-align: right;
  width: 0.2rem;
  height: 0.2rem;
  margin-bottom: 0.3rem;
}

.tipShow > div:nth-child(2) {
  margin-top: 0.07rem;
}
.tipShow > div:nth-child(2) img {
  width: 1.6rem;
  height: 1.6rem;
}
.tipShow > p {
  margin-top: 0.18rem;
  color: #040000;
  font-size: 0.3rem;
  letter-spacing: 0.25rem;
}
.tipShow > button {
  margin-top: 0.5rem;
  background: #0bc4a1;
  border: none;
  color: #fff;
  font-size: 0.3rem;
  width: 4rem;
  height: 0.7rem;
  line-height: 0.7rem;
  border-radius: 0.7rem;
}
.tipShow > button img {
  margin-left: 0.3rem;
  margin-top: 0.08rem;
  display: inline-block;
  width: auto;
  height: auto;
  vertical-align: middle;
  margin: 0 0 0 4px;
}
.page-group1 {
  background: #fff !important;
  overflow: scroll;
  text-align: left;
  color: #1c1c1c;
  font-size: 0.38rem;
  .title-m {
    margin: 0.8rem 0.6rem 1.5rem 0.6rem;
  }
  .font-p {
    font-size: 0.56rem;
    font-weight: bold;
    height: 1.2rem;
    line-height: 0.6rem;
  }
  .class-big {
    background: #f19149;
    color: #fff;
    padding: 0 10px;
    border-radius: 10%;
    font-size: 14px;
    margin-right: 20px;
    vertical-align: bottom;
    display: inline-block;
  }
  .avatar-class {
    margin: 20px 0 20px 0;
  }
  .avatar-name {
    font-size: 14px;
    font-weight: bold;
    color: #484848;
    margin-left: 10px;
  }
  .time-p {
    margin: 15px 0;
  }
  .fl {
    float: left;
    color: #949494;
  }
  .fr {
    float: right;
    color: #ee5246;
  }
  .title-m > p {
    display: table-cell;
    vertical-align: middle;
  }
  .p-image {
    width: 46px;
    border-radius: 50%;
    vertical-align: middle;
  }
  div > ul > .ui-li-core {
    background: #f2f2f2;
    border-radius: 5px;
    margin-top: 0.4rem;
    padding: 0.3rem 0.5rem;
  }
  .clas-num {
    display: inline-block;
    height: 25px;
    width: 21px;
    text-align: center;
    color: #a8a8a8;
    /* background: url(../images/class-num.png) no-repeat; */
    background-size: 100%;
    margin-right: 10px;
    font-size: 10px;
  }
  .class-time-p {
    height: 30px;
    font-size: 15px;
    margin-bottom: 10px;
    font-family: PingFangSC-Regular;
    color: #333333;
    letter-spacing: 0;
  }
  .class-time {
    margin-right: 20px;
    color: #767676;
  }
  .class-desri {
    margin: 10px 0 0 20px;
  }
  .class-desri li {
    list-style-type: initial;
    color: #767676;
  }

  .class-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-top: solid #f9f9f9;
  }
  .class-hello {
    width: 34%;
    background: #fff;
    color: #4e4e4e;
    float: left;
    font-size: 15px;
    height: 50px;
    line-height: 50px;
  }
  .class-buy {
    width: 66%;
    height: 50px;
    line-height: 50px;
    float: right;
    color: #fff;
    background: -webkit-linear-gradient(
      left,
      #3dac89,
      #3eb4ad
    ); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(
      right,
      #3dac89,
      #3eb4ad
    ); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(
      right,
      #3dac89,
      #3eb4ad
    ); /* Firefox 3.6 - 15 */
    background: linear-gradient(
      to right,
      #3dac89,
      #3eb4ad
    ); /* 鏍囧噯鐨勮娉曪紙蹇呴』鏀惧湪鏈€鍚庯級 */
  }
  .btn_app::after {
    background: rgba(0, 0, 0, 0) url(/wap/theme/default/images/ico_down1.png)
      no-repeat scroll center center / 100% auto;
  }

  /**鏁欏笀璇︽儏*/
  .detail-img {
    margin: 10px 0px;
    width: 100%;
  }
  .class-details {
    margin-top: 10px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    text-indent: 27px;
  }
  .p-details img {
    width: 100%;
  }
}

.page-group2 {
  text-align: left;
  padding: 0 0 20px 0;
  .dis-y {
    background: #fff !important;
  }

  .m-rig-40 {
    margin: 40px 15px 0 15px;
  }
  .m-rig {
    margin: 15px;
  }
  .m-rig > p {
    margin: 10px 0px 5px 0px;
  }
  .m-title {
    font-size: 18px;
    color: #333;
    margin: 10px 0;
    display: inline-block;
  }
  .m-intro {
    font-size: 15px;
    margin-top: 15px;
  }
  .my-intro {
    font-size: 15px;
    margin: 10px 0px 15px 0 !important;
  }
  .c-tags {
    font-size: 14px;
    color: #999999;
    background: #eeeeee;
    border-radius: 50px;
    padding: 2px 8px;
  }
  .play-num {
    font-size: 13px;
    margin: 3px 0;
  }

  .p-image {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 10px;
    vertical-align: middle;
  }
  .p-name {
    color: #333333;
    font-size: 0.6rem;
  }
  .p-follow {
    border: 1px solid #0bc4a1;
    border-radius: 4px;
    font-size: 12px;
    padding: 3px 8px;
    margin-top: 15px;
    color: #0bc4a1;
  }
  .class-time {
    font-size: 15px;
    margin: 10px 0;
  }
  .class-details {
    font-size: 15px;
  }

  .class-group {
    border-top: 1px solid #6666660f;
    margin-top: 25px;
  }
  .class-group > ul {
    box-shadow: 0 1px 3px 0 #6666662e;
    height: 43px;
    line-height: 43px;
    color: #333333;
    font-size: 15px;
  }
  .class-group > ul > li {
    width: 50%;
    text-align: center;
    display: inline-block;
  }
  .list-g {
    position: relative;
    left: -30px;
    background: #3dac87;
    border-radius: 5px;
    height: 4px;
    display: inline-block;
    top: 38px;
  }

  .m-class-group {
    margin-right: 0px;
  }
  .class-num {
    overflow: auto;
    white-space: nowrap;
  }
  .class-num::-webkit-scrollbar {
    display: none;
  }
  .da-color {
    background: #0bc4a1 !important;
    color: #fff !important;
    border: 1px solid #0bc4a1;
    // min-width: 100px;
    font-size: 16px;
  }
  .class-num > span {
    margin: 8px 10px 8px 0px;
    padding: 22px 18px;
    border-radius: 2px;
    text-align: center;
    display: inline-block;
    word-wrap: break-word;
    word-break: normal;
    white-space: initial;
    background: #fff;
    color: #545151;
    background: #f1f1f1;
  }

  .z-j {
    margin-top: 20px;
  }
  .m-title-details {
    display: none;
  }
  .m-title-details > ul > li {
    background: #fff;
    color: #545151;
    border: 1px solid #545151;
    width: 68%;
    padding: 6px 10px 6px 20px;
    border-radius: 2px;
    margin: 10px 0 20px 0;
    font-size: 15px;
  }

  .has_money {
    border: 1px solid #b7b7b7 !important;
    color: #b7b7b7 !important;
  }
  .class_money {
    text-align: center;
    position: absolute;
    display: inline-block;
    left: 86%;
    background: #3dac87ad;
    color: #fff;
    width: 20px;
    border-radius: 25px;
    height: 20px;
    line-height: 20px;
    font-size: 9px;
    margin-top: -2px;
  }

  .common-all li {
    margin: 15px 0;
    padding: 0 15px 15px 15px;
    border-bottom: 1px solid #eee;
  }
  .common-image {
    width: 45px;
    height: 45px;
    border-radius: 25px;
    vertical-align: middle;
    margin-left: 10px;
    position: relative;
    top: 8px;
  }
  .common-time {
    position: absolute;
    display: inline-block;
    margin-top: 35px;
    margin-left: 10px;
    font-size: 10px;
    color: #a6a9a6f0;
  }
  .common-title {
    font-size: 14px;
    margin-left: 13px;
    color: #333;
    display: inline-block;
  }
  .good_num {
    display: inline-block;
    height: 25px;
    width: 48px;
    text-align: center;
    color: #a8a8a8;
    background: url(https://kangweiwenhua.oss-cn-shanghai.aliyuncs.com/static/images/uploads/20191009/e8df3665417e523e4a7604e09920f4db.624823695346px_1221632_easyicon.net.png)
      no-repeat 2px;
    background-size: 30%;
    font-size: 13px;
    line-height: 25px;
  }
  .common-content {
    color: #333;
    font-size: 13px;
    margin-top: 22px;
    margin-left: 55px;
  }

  .spinner {
    margin: 100px auto 0;
    width: 150px;
    text-align: center;
    display: none;
    position: absolute;
    left: 50%;
    margin-left: -75px;
    z-index: 99;
    background: none;
  }

  .spinner > div {
    width: 15px;
    height: 15px;
    background-color: #868b82;

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
    animation: bouncedelay 1.4s infinite ease-in-out;
    /* Prevent first frame from flickering when animation starts */
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  .spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }

  @keyframes bouncedelay {
    0%,
    80%,
    100% {
      transform: scale(0);
      -webkit-transform: scale(0);
    }
    40% {
      transform: scale(1);
      -webkit-transform: scale(1);
    }
  }
}
</style>

